import React, { useEffect } from "react";
import "./style.scss";
import DownloadBox from "../../components/Download/DownloadBox";

function Download() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="download box">
      <p className="text">
        Some platforms are downloadable, others are web-based platforms. Below
        you will find links to the appropriate websites to download or use to
        begin trading. If you aren't sure which one best suits your needs,
        please read our <span>Overview of Support Platforms</span>
      </p>

      <div className="download-box-wrapper">
        <DownloadBox />
        <DownloadBox />
        <DownloadBox />
        <DownloadBox />
      </div>
    </div>
  );
}

export default Download;
